import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';

export class ReadMoreText extends Component {
  constructor (props) {
    super(props);

    this.state = {
      truncDesc: true,
      textBodyHeight: 0
    };

    this.toggleDesc = this.toggleDesc.bind(this);
  }

  componentDidMount () {
    this.setState({
      textBodyHeight: this.textElement.clientHeight || 0
    });
  }

  toggleDesc (e) {
    e.preventDefault();
    this.setState({ truncDesc: !this.state.truncDesc });
  }

  render () {
    const { text, unescapeText, textClass, readMoreFadeClass, truncHeightPx, bgColor } = this.props;
    const { truncDesc, textBodyHeight } = this.state;
    const truncHeight = `${truncHeightPx}px`;
    const fadeColor = `linear-fade-${bgColor}`;
    const isWrapped = textBodyHeight > truncHeightPx;

    const hideBtnStyle = { marginTop: '20px' };
    const wrapperStyling = (truncDesc && isWrapped) ? { height: truncHeight, overflow: 'hidden' } : {};
    const unescapedText = () => (<span dangerouslySetInnerHTML={ { __html: text } } />);
    const textToDisplay = unescapeText ? unescapedText() : text;

    const readMoreBtn = (
      <div className={classnames({ 'button-with-fade': truncDesc })}>
        { truncDesc && <div className={`${ readMoreFadeClass || 'fade-fa'} ${fadeColor} linear-fade`} /> }

        <button className="toggle-txt-btn btn-link" onClick={this.toggleDesc} style={ !truncDesc ? hideBtnStyle : {} }>
          { truncDesc
            ? <FormattedMessage id="elements_buttons.read_more_text.read_more" defaultMessage="Read More" />
            : <FormattedMessage id="elements_buttons.read_more_text.hide" defaultMessage="Hide" />
          }
        </button>
      </div>
    );

    return (
      <div className="read-more-text-wrapper" style={ wrapperStyling }>
        <p className={ textClass } ref={ (textElement) => { this.textElement = textElement; }}>{ textToDisplay }</p>

        { truncDesc ? null : this.props.children }

        { isWrapped && readMoreBtn }
      </div>
    );
  }
}

ReadMoreText.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  truncHeightPx: PropTypes.number,
  bgColor: PropTypes.string,
  unescapeText: PropTypes.bool,
  textClass: PropTypes.string,
  readMoreFadeClass: PropTypes.string
};
